import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Alusta toodete otsimisega

  <span style="color:#85c1dc;">**FI:**</span>
  Aloita etsimällä tuotteita

  <span style="color:#85c1dc;">**RU:**</span>
  Начните с поиска продуктов
*/
/* @__NO_SIDE_EFFECTS__ */
const m1717 = msg(
  mf`Alusta toodete otsimisega`,
  mf`Aloita etsimällä tuotteita`,
  mf`Начните с поиска продуктов`,
)

export { m1717 as 'w.wishlist.start_searching_button' }